export interface BlogListItem {
  id: string;
  title: string;
  excerpt: string;
  date: string;
  readTime: string;
  image?: string;
  slug: string;
}

export const blogPosts: BlogListItem[] = [
  {
    id: '15',
    title: 'How Estimate Signing Works (And Why It Matters for Customers)',
    excerpt: 'Estimate signing helps customers approve work quickly with full visibility. Learn what it includes, why it matters, and what to expect after signing.',
    date: 'February 2026',
    readTime: '6 min read',
    slug: 'how-estimate-signing-works'
  },
  {
    id: '14',
    title: '5 Automated Follow-Up Sequences That Convert Home Service Leads Into Paying Customers',
    excerpt: 'Learn how automated follow-up sequences can help you convert more leads into paying customers while you focus on delivering great service.',
    date: 'January 2025',
    readTime: '8 min read',
    image: '/docs/5-automated-follow-up-sequences/header.png',
    slug: '5-automated-follow-up-sequences'
  },
  {
    id: '13',
    title: 'Automated Postcard Marketing: A Game-Changer for Home Service Businesses',
    excerpt: 'Learn how automated postcard campaigns can help you reach potential customers in the neighborhoods where you already work, leveraging the power of social proof and geographic proximity.',
    date: 'January 2025',
    readTime: '10 min read',
    image: '/docs/postcard-marketing/header.png',
    slug: 'postcard-marketing-home-services'
  },
  {
    id: '12',
    title: 'Building a Referral Engine: How to Turn Every Completed Job Into 3 New Leads',
    excerpt: 'The best leads come from your existing customers. Learn how to build a systematic referral engine that turns happy customers into your best salespeople.',
    date: 'January 2025',
    readTime: '9 min read',
    slug: 'building-a-referral-engine'
  },
  {
    id: '11',
    title: 'Built for Home Services vs. Built for Everyone: Why Industry-Specific CRMs Outperform Generic Solutions',
    excerpt: 'Generic CRMs serve millions of businesses but require hours of configuration. Discover why industry-specific tools deliver better results with less effort.',
    date: 'January 2025',
    readTime: '10 min read',
    slug: 'built-for-home-services-vs-generic'
  },
  {
    id: '10',
    title: 'CRM Pricing Breakdown: The Defined CRM vs. Jobber vs. Housecall Pro — What You Actually Pay',
    excerpt: 'The sticker price tells one story, but the total cost of ownership tells another. A no-spin comparison of what you actually pay for each CRM.',
    date: 'January 2025',
    readTime: '7 min read',
    slug: 'crm-pricing-breakdown-comparison'
  },
  {
    id: '9',
    title: 'Customer Communication That Closes: SMS, Email, and In-App Messaging Best Practices',
    excerpt: 'The best home service businesses aren\'t always the most skilled—they\'re the ones that communicate best. Learn the messaging strategies that build trust and close deals.',
    date: 'January 2025',
    readTime: '10 min read',
    slug: 'customer-communication-that-closes'
  },
  {
    id: '8',
    title: 'From Quote to Cash: How Faster Invoicing Improves Your Cash Flow by 30%',
    excerpt: 'Cash flow is the lifeblood of every home service business. Learn how to reduce friction in your invoicing process and get paid faster.',
    date: 'January 2025',
    readTime: '8 min read',
    slug: 'from-quote-to-cash-faster-invoicing'
  },
  {
    id: '7',
    title: 'Reporting That Reveals Revenue Leaks: 5 Metrics Every Home Service Business Should Track',
    excerpt: 'You can\'t fix what you can\'t see. Learn the five key metrics that reveal where money is slipping through the cracks in your business.',
    date: 'January 2025',
    readTime: '11 min read',
    slug: 'reporting-that-reveals-revenue-leaks'
  },
  {
    id: '6',
    title: 'The True Cost of a Missed Lead: Why Response Time Is Your Biggest Revenue Driver',
    excerpt: 'Speed wins. Learn how much money walks out the door when leads don\'t get a timely response, and how to fix it.',
    date: 'January 2025',
    readTime: '8 min read',
    slug: 'true-cost-of-missed-lead'
  },
  {
    id: '5',
    title: 'Marketing Dashboard Guide',
    excerpt: 'A comprehensive guide to the Marketing Dashboard, including tools for managing leads, customer lists, email/SMS templates, and campaigns.',
    date: 'January 2025',
    readTime: '12 min read',
    slug: 'marketing-lists-guide'
  },
  {
    id: '1',
    title: '7 Proven Ways to Grow Your Home Service Business in 2025',
    excerpt: 'Discover actionable strategies to expand your home service business, from building a professional online presence to leveraging automation and local partnerships.',
    date: 'January 2025',
    readTime: '8 min read',
    image: '/blog/7steps/revenue.png',
    slug: '7-proven-ways-to-grow-your-home-service-business-2025'
  },
  {
    id: '2',
    title: 'The Power of Following Up: Why Customer Follow-Up is the Key to Business Growth',
    excerpt: 'Learn why customer follow-up is one of the simplest yet most effective ways to drive repeat business, build loyalty, and increase revenue for your home service company.',
    date: 'January 2025',
    readTime: '6 min read',
    image: '/blog/following-up/follow-up-infographic.png',
    slug: 'the-power-of-following-up'
  },
  {
    id: '3',
    title: 'The Power of Automated Appointment Reminders: Boosting Customer Retention and Revenue Through Smart Scheduling',
    excerpt: 'Learn how implementing an intelligent appointment reminder system can dramatically reduce no-shows, build stronger customer relationships, and drive recurring revenue for your home service business.',
    date: 'September 2025',
    readTime: '12 min read',
    image: '/blog/appointment-reminders/image.png',
    slug: 'automated-appointment-reminders-customer-retention'
  },
  {
    id: '4',
    title: 'The Essential Metrics Every Home Service Business Should Track: Your Guide to Data-Driven Growth',
    excerpt: 'Discover the key performance indicators that separate thriving service businesses from those that plateau. Learn which numbers to track, how to calculate them, and how to turn data into actionable growth strategies.',
    date: 'September 2025',
    readTime: '15 min read',
    image: '/blog/metrics-kpis/dashboard.png',
    slug: 'essential-metrics-home-service-business-kpis'
  }
];
